import React, { useState } from 'react';

import styled from 'styled-components';

import useConfigurations from '@hooks/Configurations/UseConfigurations';
import useTransactionLockedStatus from '@hooks/Utils/UseTransactionLockedStatus';

import Money from '@components/Gui/Money';
import NwDivider from '@components/Gui/NwDivider';
import NwDrawer from '@components/Gui/NwDrawer';
import NwLink from '@components/Gui/NwLink';

import ExchangeRateForm from './TransactionDetailForms/ExchangeRateForm';
import TransactionAmountForm from './TransactionDetailForms/TransactionAmountForm';
import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const Container = styled.div`
    padding: 0.5rem 0;
    .transaction-amount-line {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .transaction-amount {
            p {
                font-size: ${(props) => props.theme.FontSizeSm};
                margin-bottom: 0;
            }
        }
        .transaction-amount-actions {
            text-align: right;
        }
    }
`;

const TransactionAmount = ({ transaction, onUpdateTransaction, accountingUnlock }) => {
    const [editable, setEditable] = useState(false);
    const [touchForm, setTouchForm] = useState(false);

    const configurations = useConfigurations();

    //const isTransactionLocked = isLocked(transaction);

    const lock = useTransactionLockedStatus(transaction);
    const canEdit = !lock.isLocked || (lock.isAccountant && accountingUnlock);

    const handleAmountUpdated = () => {
        setTouchForm(false);
        setEditable(false);
        if (onUpdateTransaction) {
            onUpdateTransaction();
        }
    };

    return (
        <Container>
            <NwDivider dark icon={byPrefixAndName.fasl['sack-dollar']} textSize="medium">
                Amount
            </NwDivider>
            {transaction && (
                <div className="transaction-amount-line">
                    <div className="transaction-amount">
                        {(!['Flat', 'Units'].includes(transaction.TypeQuantity) || transaction.Quantity > 1) && (
                            <p>
                                <Money amount={transaction.SingleFee} currency={transaction.Currency} /> x{' '}
                                {transaction.Quantity} {transaction.TypeQuantity}
                            </p>
                        )}
                        <h3>
                            <Money
                                highlightCurrency
                                redIfNegative
                                amount={transaction.TotalFee}
                                currency={transaction.Currency}
                            />
                        </h3>
                        {transaction.ExternalFee ? (
                            <p>
                                MODEL FEE:&nbsp;
                                <Money amount={transaction.ExternalFee} currency={transaction.Currency} />
                            </p>
                        ) : null}
                    </div>
                    <div className="transaction-amount-actions">
                        <NwLink
                            disabled={!canEdit}
                            onClick={() => {
                                setEditable(true);
                            }}
                            icon={byPrefixAndName.fasl['sack-dollar']}
                        >
                            Change Amount
                        </NwLink>
                        <br />
                        <br />
                        {transaction.Currency !== configurations.defaultCurrency && (
                            <ExchangeRateForm
                                disabled={!canEdit}
                                transaction={transaction}
                                onUpdate={onUpdateTransaction}
                            />
                        )}
                    </div>
                </div>
            )}
            {editable && (
                <NwDrawer
                    touchForm={touchForm}
                    onTouchForm={setTouchForm}
                    onClose={() => {
                        setEditable(false);
                        setTouchForm(false);
                    }}
                    title="Edit Amount"
                >
                    <TransactionAmountForm
                        transaction={transaction}
                        onSave={handleAmountUpdated}
                        onCancel={() => setEditable(false)}
                    />
                </NwDrawer>
            )}
        </Container>
    );
};

export default TransactionAmount;
